import { APICore } from './apiCore'

const api = new APICore()

function getSecciones (params) {
  const baseUrl = '/secciones'
  return api.get(baseUrl, params)
}

function getSeccion (id) {
  const baseUrl = `/secciones/${id}`
  return api.get(baseUrl, {})
}

function addSeccion (params) {
  const baseUrl = '/secciones'
  return api.create(baseUrl, params)
}

function updateSeccion (params) {
  const baseUrl = '/secciones'
  return api.update(baseUrl, params)
}

function deleteSeccion (params) {
  const baseUrl = '/secciones'
  return api.delete(baseUrl, params)
}

export { getSecciones, getSeccion, addSeccion, updateSeccion, deleteSeccion }
